import { BASE_URL } from '@/config'

export async function getTypes_Control() {
  try {
    const response = await fetch(`${BASE_URL}/graphs/type-control/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar tipos de controle')
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Erro ao buscar tipos de controle:', error)
    throw error
  }
}

export async function getTypes_ControlByIdEnterprise(enterpriseId) {
  // console.log('ID da empresa getTypes_ControlByIdEnterprise:', enterpriseId)
  try {
    const response = await fetch(
      `${BASE_URL}/graphs/type-control/enterprise/${enterpriseId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        errorData.message || 'Erro ao buscar tipos de controle da empresa'
      )
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error('Erro ao buscar tipos de controle da empresa:', error)
    throw error
  }
}
